import { Col, Input, Row } from "reactstrap";
import Toggle from "../../../../../components/common/Toggle/Toggle";
import styles from "./Availability.module.scss";

const Availability = () => {
  return (
    <div className="mt-3">
      <div className={styles["heading"]}>Availability</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>
          <Row className="g-0 align-items-center justify-content-between">
            <Col xs={"auto"} lg={3} xxl={2}>Online Status:</Col>
            <Col xs={"auto"} lg={9} xxl={10} className="d-flex py-2">
              <Toggle />
            </Col>
          </Row>
          <Row className="g-0 row-gap-1">
            <Col lg={3} xxl={2}>Availability hours:</Col>
            <Col lg={8} xl={6} xxl={5}>
              <Row className="g-0 row-gap-1 align-items-center mb-2">
                <Col sm={4} className="pe-sm-2">
                  <div>On Working days:</div>
                </Col>
                <Col sm={4} className="pe-sm-2">
                  <div>
                    <Input placeholder="00:00" />
                  </div>
                </Col>
                <Col sm={4}>
                  <div>
                    <Input placeholder="00:00" />
                  </div>
                </Col>
              </Row>
              <Row className="g-0 row-gap-1 align-items-center">
                <Col sm={4} className="pe-sm-2">
                  <div>On Weekend:</div>
                </Col>
                <Col sm={4} className="pe-sm-2">
                  <div>
                    <Input placeholder="00:00" />
                  </div>
                </Col>
                <Col sm={4}>
                  <div>
                    <Input placeholder="00:00" />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="g-0 row-gap-1">
            <Col lg={3} xxl={2}>Availability hours:</Col>
            <Col lg={9} xxl={10}>
              <Input type="textarea" />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Availability;